export default __webpack_public_path__ + "static/media/BrainBreak cards68.c6276176.png";